import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ListItem from '@mui/material/ListItem';
import React from 'react';
import { socialMediaLinks } from '../../helpers/config/social-links';
import logo from '../../logo.svg';
import './Header.scss';
import NereusConnectButton from '../NereusConnectButton/NereusConnectButton';
import { slide as Menu } from 'react-burger-menu'
import {useBreakpointContext} from "../../context-providers/BreakpointProvider";
import { Link } from 'react-router-dom';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

function Header() {
    const { md } = useBreakpointContext();
    const [menuOpened, setMenuOpened] = React.useState(false);

    const links = [{
        to: '/',
        label: 'Dashboard'
    }, {
        href: 'https://points.nereus.finance',
        label: 'Points'
    }, {
        to: '/ecosystem',
        label: 'Ecosystem'
    }, {
        to: '/stake',
        label: 'Stake'
    }, {
        to: '/stats',
        label: 'Stats'
    }, {
        href: 'https://www.nereus.finance/blog',
        label: 'Blog'
    }];

    function menuStateChanged({  isOpen }: any) {
        setMenuOpened(isOpen);
    }

    if (md) {
        return (
            <header className="App-header">
                <div className="content-container">
                    <div className="App-header__left flex items-center">
                        <Link to="/"><img src={logo} className="App-logo" alt="logo" /></Link>
                        <nav className="ml-10">
                            {links.map((link, index) => {
                                if (link.to) {
                                    return <Link key={index} to={link.to}>{link.label}</Link>
                                } else {
                                    return <a key={index} href={link.href} target="_blank"
                                              rel="noopener noreferrer" className="App-header__externalLink">{link.label}<OpenInNewIcon/></a>
                                }
                            })}
                        </nav>

                    </div>
                    <div className="App-header__right">
                        <NereusConnectButton />
                    </div>
                </div>

            </header>
        )
    } else {
        return (
            <>
                <header className="App-header">
                    <Menu isOpen={menuOpened} onStateChange={ menuStateChanged }
                        customCrossIcon={(
                            <svg style={{ backgroundColor: 'transparent'}} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M18.3 5.7107C17.91 5.3207 17.28 5.3207 16.89 5.7107L12 10.5907L7.10997 5.7007C6.71997 5.3107 6.08997 5.3107 5.69997 5.7007C5.30997 6.0907 5.30997 6.7207 5.69997 7.1107L10.59 12.0007L5.69997 16.8907C5.30997 17.2807 5.30997 17.9107 5.69997 18.3007C6.08997 18.6907 6.71997 18.6907 7.10997 18.3007L12 13.4107L16.89 18.3007C17.28 18.6907 17.91 18.6907 18.3 18.3007C18.69 17.9107 18.69 17.2807 18.3 16.8907L13.41 12.0007L18.3 7.1107C18.68 6.7307 18.68 6.0907 18.3 5.7107Z" fill="white"/>
                            </svg>
                        )}
                        customBurgerIcon={(
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7Z" fill="white"/>
                            </svg>
                        )}
                    >
                        <div style={{margin: '24px 24px'}}>
                            <img src={logo} className="App-logo" alt="logo" />
                        </div>
                        {links.map((link, index) => {
                            if (link.to) {
                                return <ListItem key={index}><Link onClick={() => setMenuOpened(false)} to={link.to}>{link.label}</Link></ListItem>
                            } else {
                                return <ListItem key={index}><a onClick={() => setMenuOpened(false)} href={link.href} target="_blank"
                                                                rel="noopener noreferrer" className="App-header__externalLink">{link.label}<OpenInNewIcon/></a></ListItem>
                            }
                        })}
                        <Accordion sx={{ backgroundColor: 'inherit', color: 'white' }} disableGutters elevation={0}>
                            <AccordionSummary sx={{ margin: 0 }}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="community-submenu-content"
                            >
                                <ListItem>Community</ListItem>
                            </AccordionSummary>
                            <AccordionDetails className="ml-2">
                                {socialMediaLinks.map((link, index) => (
                                    <ListItem className="App-header__communityItem" key={index}><a target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpened(false)} href={link.link}><span>{link.name}</span>{link.icon}</a></ListItem>
                                ))}
                            </AccordionDetails>
                        </Accordion>
                    </Menu>
                    <div className="content-container">
                        <div className="App-header__left">

                        </div>
                        <div className="App-header__right">
                            <NereusConnectButton />
                        </div>
                    </div>
                </header>
                <div style={{minHeight: 66}}/>
            </>
        )
    }

}

export default Header;